import React from 'react';
import { VimeoVideo } from '@components/VimeoVideo';
import {
  VideoContentWrapper,
  VideoContainer,
  VideoWrapper,
  BgLeftPlaceholderCloudImage,
  FrameLeftPlaceholderCloudImage,
  BgRightPlaceholderCloudImage,
  FrameRightPlaceholderCloudImage,
  StyledPlaceholderCloudImage,
} from './SiteToSeeNewSection.styles';

const VIDEO_URL = 'https://player.vimeo.com/video/652971906?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';

export const SiteToSeeVideoSectionDesktop: React.FC<{ isVisible: boolean }> = props => {
  const { isVisible } = props;
  const LeftBgFlower = 'wedding-website/site-to-see/bg-flower1.jpg';
  const RightBgFlower = 'wedding-website/site-to-see/bg-flower2.jpg';
  const LeftFrameFlower = 'wedding-website/site-to-see/frame-flower1.jpg';
  const RightFrameFlower = 'wedding-website/site-to-see/frame-flower2.jpg';
  return (
    <VideoContentWrapper>
      <VideoContainer>
        <BgLeftPlaceholderCloudImage isMainSrcShown={isVisible} src={LeftBgFlower} width="340" height="340" />
        <FrameLeftPlaceholderCloudImage isMainSrcShown={isVisible} src={LeftFrameFlower} width="361" height="361" />
        <VideoWrapper>
          {isVisible && (
            <VimeoVideo
              embedUrl={VIDEO_URL}
              title="What a site to see"
              alt="wedding-website-site-to-see"
              autoPlay
              background
              controls={false}
              autoPause={false}
              muted
              loop
              cover
            />
          )}
        </VideoWrapper>
        <FrameRightPlaceholderCloudImage isMainSrcShown={isVisible} src={RightFrameFlower} width="345" height="345" />
        <BgRightPlaceholderCloudImage isMainSrcShown={isVisible} src={RightBgFlower} width="340" height="340" />
      </VideoContainer>
    </VideoContentWrapper>
  );
};

export const SiteToSeeVideoSectionMobile: React.FC<{ isVisible: boolean }> = props => {
  const { isVisible } = props;
  return (
    <StyledPlaceholderCloudImage
      src="wedding-website/site-to-see/site-to-see-img-mobile.jpg"
      alt="Site To See Text"
      isMainSrcShown={isVisible}
      width="100%"
      height="117px"
    />
  );
};

export const SiteToSeeVideoSection: React.FC<{ isVisible: boolean; isVisibleMobile: boolean }> = props => {
  const { isVisible, isVisibleMobile } = props;
  return (
    <>
      <SiteToSeeVideoSectionDesktop isVisible={isVisible} />
      <SiteToSeeVideoSectionMobile isVisible={isVisibleMobile} />
    </>
  );
};

export default SiteToSeeVideoSection;
